import { useEffect, useRef } from "react"
import type { RefObject } from "react"

/** Mirror into a ref the caller already declared, for when the ref must exist before its value can be computed. */
export function useSyncRef<T>(ref: RefObject<T>, value: T): void {
  useEffect(() => {
    ref.current = value
  }, [ref, value])
}

/**
 * A ref holding the last COMMITTED value, for callbacks that read it after an `await`, where a render closure
 * is stale. Mirrors only: refs that ARE the storage stay a plain `useRef`.
 * Keep the write in the effect — `react-hooks/refs` rejects a render-phase one, and discarded renders would publish.
 */
export function useLatest<T>(value: T): RefObject<T> {
  const ref = useRef(value)
  useSyncRef(ref, value)
  return ref
}
